import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import './SettingsDrawer.less'
import { PathwayDetailFieldsForManageFragment } from '../ManagePathwayPage.codegen'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { TopbarDrawer } from '../../topic-detail-page/components/drawers/TopbarDrawer'
import { PathwayGeneralDrawerContent } from './PathwayGeneralDrawerContent'
import { PathwayVersionsDrawerContent } from './PathwayVersionsDrawerContent'

export const PathwaySettingsDrawer: FC<{
  show: boolean
  dataTest?: string
  onHide: () => void
  pathway: PathwayDetailFieldsForManageFragment
}> = ({ show, dataTest, onHide, pathway }) => {
  return (
    <TopbarDrawer show={show} onHide={onHide} isEditMode>
      <Tabs data-test={dataTest} size="lg" isLazy>
        <TabList>
          <Tab w="50%" borderRadius={0} data-test="GeneralButton">
            <Trans>General</Trans>
          </Tab>
          <Tab w="50%" borderRadius={0} data-test="VersionsButton">
            <Trans>Versions</Trans>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <PathwayGeneralDrawerContent
              pathway={pathway}
              hideDrawer={onHide}
            />
          </TabPanel>
          <TabPanel p={0}>
            <PathwayVersionsDrawerContent isEditMode pathwayId={pathway.id} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </TopbarDrawer>
  )
}
